export class Constants {
  //Screen Names(main menus)  constants
  public static ManageRoleScreen : String = 'Manage Roles';
  public static AddFeaturesToRoleScreen : String = 'Add Features To Role';
  public static AddActionsToRoleScreen : String = 'Add Actions To Role';
  public static ManageContactsScreen : String = 'Manage Contacts';
  public static ManageContactGroupsScreen : String = 'Manage Contact Groups';
  public static ManageLeads : String = 'Manage Leads';
  public static CallCenterScreen : String = 'Call Center';
  public static ManageUsersScreen : String = 'Manage Users';
  public static DigitalMISAchievement : String = 'Digital MIS Achievement';

  public static ManageActivity: string = "Manage Activities";
  public static ActivityApproval: string = "Activities Approval";
  public static AppointmentReportScreen: string = "Appointment Report";
  public static TIMLReportScreen : string  = "TIML Report";
  public static DialerLeadsScreen: string = "Dialer Leads Upload";
  public static AutoDialConfigurationScreen : string = "Auto Dial Configuration";
  public static InboundCallLogs : string  = "Inbound Call Logs";
  public static ManagePackageLeads : string = "Manage Package Leads";


  //screen action names
  public static ViewAction : String = 'View';
  public static AddEditAction : String = 'Add / Edit';
  public static ActivateDeactivateAction : String = 'Active / Deactive';
  public static ExportAction : String = 'Export';

  public static ActivityFeatureId : number = 17;
  public static ActivityApprovalFeatureId : number = 18;
  public static CampaignFeatureId : number = 20;
  public static CampaignApprovalFeatureId : number = 26;
  public static AcitivityLeadsFeatureId : number = 50;
  public static ManageLeadsFeatureId : number = 11;
  public static AppointmentFeatureId : number = 51;
  public static PackageLeadsFeatureId : number = 58;
}